import React from 'react';
import Link from 'next/link';
import { Trans, useTranslation } from 'react-i18next';

interface OffersProps {
  isEligibleForOffers: boolean;
}

const Offers: React.FC<OffersProps> = ({ isEligibleForOffers }) => {
  const { t } = useTranslation(['checkout', 'common']);

  return (
    <div>
      {isEligibleForOffers && (
        <div className="my-4 p-[4px] max-w-[345px] mx-auto rounded-xl bg-linear-to-r from-[#172c7a] via-[#EFF2FF] to-[#1638AC]">
          <div className="flex flex-col flex-1 p-5 rounded-xl bg-linear-to-b from-[#04144e] to-[#0b257c] text-white">
            <h3 className="text-white text-lg font-bold pb-4">
              {t('checkout:youHaveExclusiveOffersWaiting')}
            </h3>
            <p className="pb-6 text-base font-normal">
              <Trans
                i18nKey="checkout:youHaveExclusiveOffersWaitingDescription"
                components={{
                  strong: <strong />
                }}
              />
            </p>
            <Link
              href="/ticketsTab/offers/unclaimed"
              target="_blank"
              rel="noreferrer"
              className="bg-primary-400 text-white hover:text-white text-base font-bold px-4 py-3 rounded-full flex items-center justify-center"
            >
              {t('common:buttons.learnMore')}
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default Offers;
